import AuthServices from "@/services/auth/AuthServices"
import { defineStore } from "pinia"
import { computed, ref } from "vue"
import { useRouter } from "vue-router"

export const useAuthStore = defineStore('auth', () => {
    const status = ref('not-authenticated')//checking, authenticated, checking-me
    const user = ref(null)
    const router = useRouter()

    const setUserAuthenticated = respLogin => {
      user.value = respLogin
      status.value = 'authenticated'
      console.log('respLogin', respLogin)

      return  respLogin.token
    }
  
    const login = async (email, password) => {
      try {
        status.value = 'checking'
  
        const respLogin = await AuthServices.login({ email, password })
  
        const token = setUserAuthenticated(respLogin)
  
        localStorage.setItem('cc-user-token', token)
      } catch (err) {
        console.log(err)
        user.value = null
        status.value = 'not-authenticated'
        localStorage.removeItem('cc-user-token')
        throw new Error(err)
      }
    }
    
    const logout = () => {
      user.value = null
      status.value = 'not-authenticated'
      localStorage.removeItem('cc-user-token')
      
      router.push('/').then(() => {
        //
      })
    }
  
    const checkAuth = async () => {
      try{
        status.value = 'checking-me'
        //LLAMAMOS AL SERVICIO PARA OBTENER USUARIO MEDIANTE TOKEN (y datos del carrito)
        const token = localStorage.getItem('sg-user-token')
        if(!token){
          logout()
        } else {
          status.value = 'authenticated'
        }
      }catch(err){
        logout()
      }   
    }
  
    const isLoggedIn = computed(() => status.value === 'authenticated')
    const isCheckingMeAuth = computed(() => status.value === 'checking-me')

    return { 
      status, 
      user,
      isLoggedIn,
      isCheckingMeAuth,
      login, 
      logout, 
      checkAuth,
    }
  })